// extracted by mini-css-extract-plugin
export var actions = "_th-4";
export var item = "_th-1";
export var price = "_th-3";
export var quantity = "_th-2";
export var table = "_th-0";